module.exports = __webpack_public_path__ + "static/media/Done-3.e2f017f9.png";